import { render, staticRenderFns } from "./RepAdminList.vue?vue&type=template&id=64dca0cc&"
import script from "./RepAdminList.vue?vue&type=script&lang=js&"
export * from "./RepAdminList.vue?vue&type=script&lang=js&"
import style0 from "./RepAdminList.vue?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/repadmin.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports